export const ModalIds = {
  SHARE_VIEW_LINK: "share-view-link-modal",
  SHARE_PROJECT: "share-project-modal",
} as const;

export type ModalId = (typeof ModalIds)[keyof typeof ModalIds];
